// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';

const OpenPipProgramsPipNumberCriteria = props =>
    <section className='open-pips-pip-number-criteria'>
        <LabeledCriteria
            className='pin-criteria'
            isRequired={false}
            label='PIP_NUMBER'
            maxLength='17'
            onInputChange={props.onPipNumberInputChange}
            placeholder='PIP_NUMBER'
            type='text'
            value={props.pipNumber}
        />
    </section>;

OpenPipProgramsPipNumberCriteria.displayName = 'OpenPipProgramsPipNumberCriteria';
OpenPipProgramsPipNumberCriteria.propTypes = {
    onPipNumberInputChange: PropTypes.func.isRequired,
    pipNumber: PropTypes.string.isRequired
};

export default OpenPipProgramsPipNumberCriteria;




// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/components/open-pip-programs-pip-number-criteria.js